module.exports = __webpack_public_path__ + "static/media/ambo.bfdc2026.png";